<template>
  <div>
    <v-tabs
      v-model="localActiveTab"
      background-color="transparent"
      color="primary"
      grow
    >
      <v-tab
        v-for="(item, index) in value"
        :key="index"
        :ripple="false"
        :value="item.name"
      >
        {{ item.name }}
      </v-tab>

      <div class="py-2" />

      <v-tab-item
        v-for="(item, index) in computedValue"
        :key="index"
        class="transparent"
      >
        <extra-shown v-model="item.value" :font-color="palette.textColor" />
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import ExtraShown from "@/view/components/Product/extraShown";

export default {
  name: "detailsTab",
  components: { ExtraShown },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    activeTab: {
      type: [String, Number],
      default: null,
    },
    opened: {
      type: Boolean,
      default: false,
    },
    palette: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      localActiveTab: null,
    };
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("update:value", val);
      },
    },
  },
  watch: {
    activeTab: {
      immediate: true,
      handler(newVal) {
        this.localActiveTab = newVal;
      },
    },
    localActiveTab(newVal) {
      this.$emit("update:activeTab", newVal);
    },
    opened(newVal) {
      if (newVal && this.value.length > 0) {
        const firstTabName = this.value[0].name;
        this.localActiveTab = firstTabName;
        this.$emit("update:activeTab", firstTabName);
      }
    },
  },
  mounted() {
    if (this.activeTab) {
      this.localActiveTab = this.activeTab;
    } else if (this.value.length > 0) {
      const firstTabName = this.value[0].name;
      this.localActiveTab = firstTabName;
      this.$emit("update:activeTab", firstTabName);
    }
  },
};
</script>

<style scoped>
.v-tabs >>> .v-tabs-items {
  background-color: transparent !important;
}

.v-tabs >>> .v-tabs-slider-wrapper {
  display: block !important;
}
</style>
